import { Controller } from '@hotwired/stimulus'

export default class TypoController extends Controller {
  static values = {
    noTextMsg: String,
    tooLongMsg: String
  }

  connect() {
    document.addEventListener('keydown', this.handleGlobalKeydown)
    document.addEventListener('click', this.handleDocumentClick)
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleGlobalKeydown)
    document.removeEventListener('click', this.handleDocumentClick)
  }

  getTypo() {
    let selection = window.getSelection()

    if (
      selection !== null &&
      selection.rangeCount > 0 &&
      !selection.isCollapsed
    ) {
      try {
        let pre
        let post
        let range = selection.getRangeAt(0)
        let sel = range.toString()
        let preRange
        let postRange
        let boundingLength = 80

        preRange = document.createRange()
        preRange.setStartBefore(range.startContainer.ownerDocument.body)
        preRange.setEnd(range.startContainer, range.startOffset)
        pre = preRange.toString()

        postRange = document.createRange()
        postRange.setStart(range.endContainer, range.endOffset)
        postRange.setEndAfter(range.endContainer.ownerDocument.body)
        post = postRange.toString()

        pre = pre
          .slice(-boundingLength)
          .replace(/[\s\n]+/gm, ' ')
          .replace(/^[^\s]*\s+/, '')
        post = post
          .slice(0, boundingLength)
          .replace(/[\s\n]+/gm, ' ')
          .replace(/\s+[^\s]*$/, '')

        return { pre, sel, post }
      } catch (error) {
        console.error('Error getting typo:', error)
        return null
      }
    }

    return null
  }

  isCtrlEnter(event) {
    return (event.ctrlKey || event.metaKey) && event.key === 'Enter'
  }

  processTypoReport() {
    let typo = this.getTypo()

    if (!typo) {
      // eslint-disable-next-line no-alert
      alert(this.noTextMsgValue)
      return false
    }

    if (typo.sel.length > 250) {
      // eslint-disable-next-line no-alert
      alert(this.tooLongMsgValue)
      return false
    }

    this.loadTurboStream(this.typoReportUrl(typo))
    return true
  }

  handleGlobalKeydown = (event) => {
    if (
      this.isCtrlEnter(event) &&
      !event.target.closest('input, textarea, [contenteditable="true"]')
    ) {
      event.preventDefault()
      this.processTypoReport()
    }
  }

  typoReportUrl(typoData) {
    let url = new URL(window.location.origin)

    url.pathname = '/typos/new'
    url.searchParams.set('typo[ref]', window.location.href)
    url.searchParams.set('typo[post]', typoData.post)
    url.searchParams.set('typo[pre]', typoData.pre)
    url.searchParams.set('typo[sel]', typoData.sel)

    return url.href
  }

  async loadTurboStream(url) {
    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      if (!response.ok) {
        throw new Error(
          `Failed to load turbo stream: ${response.status} ${response.statusText}`
        )
      }
      const html = await response.text()
      Turbo.renderStreamMessage(html)
    } catch (error) {
      console.error('Ошибка загрузки turbo stream:', error)
    }
  }

  handleDocumentClick = (event) => {
    const button = event.target.closest('[data-typo-action="closeModal"]')
    if (button) {
      const activeModal = document.querySelector(
        '[data-modal].is-active, .modal.is-active'
      )

      if (activeModal) {
        activeModal.classList.remove('is-active')
      }
    }

    const typoBtn = event.target.closest('[data-typo-btn]')
    if (typoBtn) {
      this.processTypoReport()
    }
  }
}
